import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import ImmutableRenderMixin from 'react-immutable-render-mixin';
import {Link} from 'react-router';
import {List, Record} from 'immutable';
import WorkingSetTypeface from 'records/WorkingSetTypeface';
import {Request, GET, POST, DELETE} from 'requests';
import {default as RequestsMixin, IS_DONE, IS_NOT_ALLOWED} from 'requests/RequestsMixin';
import {ResourcesMatching, Requesting, Done} from 'requests/components';
import NavLink from 'components/NavLink';
import {default as Spinner, SIZE_LARGE} from 'components/Spinner';
import Header from './Header';
import {default as UpgradeModal, MAX_TYPEFACES_PER_KIT} from '../components/UpgradeModal';
import TypefaceExample from './TypefaceExample';
import TypefaceFacets from './TypefaceFacets';
import {sortTypefaces} from '../utils/records';

const mapStateToProps = (state, ownProps) => {
  const kitToken = ownProps.params.kitToken;

  return {
    kitToken,
    requests: state.requests,
  };
};

const AddWorkingTypeface = Record({
  typefaceId: null,
});

const AddTypefaceController = createReactClass({
  propTypes: {
    dispatch: PropTypes.func.isRequired,
    kitToken: PropTypes.string.isRequired,
    requests: PropTypes.object.isRequired,
  },

  mixins: [RequestsMixin, ImmutableRenderMixin],

  getInitialState() {
    return {
      showUpgradeModal: false,
      interimAdditions: List(),
    };
  },

  componentWillMount() {
    this.setRequest({
      subscription: new Request({
        method: GET,
        url: ['api', 'subscriptions'],
      }),
    });

    this.setRequest({
      kit: new Request({
        method: GET,
        url: ['api', 'kits', this.props.kitToken],
      }),
    });

    this.setRequest({
      typefaces: new Request({
        method: GET,
        url: ['api', 'typefaces'],
      }),
    });

    this.setRequest({
      workingSetTypefaces: new Request({
        method: GET,
        url: ['api', 'kits', this.props.kitToken, 'working-set-typefaces'],
      }),
    });
  },

  transitions(register) {
    register({
      request: this.requests.addWorkingSetTypeface,
      to: IS_DONE,
      call(rm) {
        this.setState({interimAdditions: List()});
      },
    });

    register({
      request: this.requests.addWorkingSetTypeface,
      to: IS_NOT_ALLOWED,
      call(rm) {
        this.setState({interimAdditions: List()});
      },
    });
  },

  handleRequestToUpgrade() {
    location.assign('/upgrade');
  },

  handleHideUpgradeModal() {
    this.setState({
      showUpgradeModal: false,
    });
  },

  handleAddTypefaceClicked(typeface) {
    const {subscription, workingSetTypefaces} = this.resources();

    if (workingSetTypefaces.size < subscription.workingSetTypefacesAllowed) {
      this.setState({
        interimAdditions: this.state.interimAdditions.push(
          new WorkingSetTypeface({typeface: typeface.id})
        ),
      });

      this.setRequest({
        addWorkingSetTypeface: new Request({
          url: ['api', 'kits', this.props.kitToken, 'working-set-typefaces'],
          method: POST,
          record: new AddWorkingTypeface({
            typefaceId: typeface.id,
          }),
        }),
      });
    } else {
      this.setState({
        showUpgradeModal: true,
        upgradeModalReason: MAX_TYPEFACES_PER_KIT,
      });
    }
  },

  handleDeleteTypefaceClicked(workingSetTypeface) {
    this.setRequest({
      deleteWorkingSetTypeface: new Request({
        url: ['api', 'kits', this.props.kitToken, 'working-set-typefaces', workingSetTypeface.id],
        method: DELETE,
        record: workingSetTypeface,
      }),
    });
  },

  resources() {
    const rm = this.resourceManager();

    return {
      subscription: rm.type(this.requests.subscription, 'subscriptions').get(),
      kit: rm.type(this.requests.kit, 'kits').get(),
      typefaces: rm.type(this.requests.typefaces, 'typefaces').all(),
      workingSetTypefaces: rm.type(this.requests.workingSetTypefaces, 'working-set-typefaces').all(),
    };
  },

  renderTypefaces() {
    const {
      subscription,
      typefaces,
      workingSetTypefaces,
    } = this.resources();
    const args = {
      typefaces: sortTypefaces(typefaces.filter((i) => i.system)),
      workingSetTypefaces: workingSetTypefaces.concat(this.state.interimAdditions),
    };

    return (
      <div className="row">
        <div className="col-xs-9">
          <TypefaceExample
            {...args}
            onTypefaceSelected={this.handleAddTypefaceClicked}
            onTypefaceDeselected={this.handleDeleteTypefaceClicked}
          />
        </div>
        <div className="col-xs-3">
          <TypefaceFacets
            {...args}
          />
        </div>

        <UpgradeModal
          isOpen={this.state.showUpgradeModal}
          reason={this.state.upgradeModalReason}
          subscription={subscription}
          onOkayClicked={this.handleHideUpgradeModal}
          onUpgradeClicked={this.handleRequestToUpgrade}
          onCloseClicked={this.handleHideUpgradeModal}
        />
      </div>
    );
  },

  renderSpinner() {
    return (
      <div className="well bg-white will-fill-page p-xs-a-lg is-loading">
        <Spinner size={SIZE_LARGE} />
      </div>
    );
  },

  renderMain() {
    const {kitToken} = this.props;
    const {kit} = this.resources();

    return (
      <div className="well bg-white will-fill-page p-xs-a-lg">
        <Link to={`/kits/${kitToken}/typefaces`} className="link-dashed-none">&lsaquo; Back to {kit.name}</Link>
        <Header heading={'Add Typefaces'} donePath={`/kits/${kitToken}/typefaces`}>
          <NavLink to={`/kits/${kitToken}/typefaces/new`}>All Typefaces</NavLink>
          <NavLink to={`/kits/${kitToken}/typefaces/upload`}>Upload a Typeface</NavLink>
        </Header>
        {this.renderTypefaces()}
      </div>
    );
  },

  render() {
    const requests = [
      this.requests.kit,
      this.requests.subscription,
      this.requests.workingSetTypefaces,
      this.requests.typefaces,
    ];

    return (
      <ResourcesMatching manager={this.resourceManager()}>
        <Requesting any={requests} render={this.renderSpinner} />
        <Done all={requests} render={this.renderMain} />
      </ResourcesMatching>
    );
  },
});

export default connect(mapStateToProps)(AddTypefaceController);



// WEBPACK FOOTER //
// ./app/javascript/views/Kits/components/AddTypefaceController.js